<template>
    <div v-if="brands.length">
        <div
            v-for="group in cartGroups"
            :key="group.BrandID"
            class="v2-retailer-cart__brand"
            :class="'js-brand-' + group.BrandID"
        >
            <router-link
                :to="`/account/brands/${group.BrandID}`"
                class="v2-retailer-cart__brand-title"
            >
                {{ brandName(group.BrandID) }}
            </router-link>
            <list-item
                v-for="product in group.Items"
                :key="product.ItemID"
                :product="product"
                :brand="brandInfo(product.BrandID)"
                @onClickToRequestAccess="openRequestAccessModal"
                @onChangeItem="itemData => $emit('onChangeItem', itemData)"
                @onRemoveItem="itemID => $emit('onRemoveItem', itemID)"
            />
        </div>

        <request-access-modal
            :is-open="isOpenRequestAccessBrandModal"
            :brand="requestAccessBrand"
            @onConfirm="sendBrandAccessRequest"
            @onClose="closeRequestAccessModal"
        />
    </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

import ListItem from './ListItem'
import RequestAccessModal from '@/components/Cabinet/Retailer/Brands/RequestAccessModal'

import checkDemoUser from '@/mixins/checkDemoUser.js'

export default {
    name: 'CartList',
    components: {
        ListItem,
        RequestAccessModal
    },
    mixins: [checkDemoUser],
    data() {
        return {
            requestAccessBrand: null,
            isOpenRequestAccessBrandModal: false
        }
    },
    computed: {
        ...mapState('cart', ['cartGroups']),
        ...mapGetters('cart', ['cartIsEmpty']),
        ...mapState('retailerBrand', ['brands']),
        ...mapGetters('retailerBrand', ['brandName'])
    },
    created() {
        this.getBrands({ all: 1 })
    },
    methods: {
        ...mapActions('retailerBrand', ['getBrands', 'requestAccessToBrand']),
        brandInfo(id) {
            return this.brands.find(brand => brand.BrandID == id) || {}
        },
        openRequestAccessModal(brandData) {
            this.requestAccessBrand = brandData
            this.isOpenRequestAccessBrandModal = true
        },
        closeRequestAccessModal() {
            this.requestAccessBrand = null
            this.isOpenRequestAccessBrandModal = false
        },
        sendBrandAccessRequest(brand) {
            if (this.isDemoUserMode()) return

            this.requestAccessToBrand(brand.BrandID).then(() => {
                this.getBrands({ all: 1 })

                this.$notify({
                    type: 'success',
                    text: `Запрос доступа к скрытым изделиям бренда “${brand.BrandName}” отправлены`
                })
            })

            this.requestAccessBrand = null
            this.isOpenRequestAccessBrandModal = false
        }
    }
}
</script>
